import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { stopPropagation } from '../../../../helpers/common';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
const SlideSearchListSelectAllCheckbox = (props) => {
    const { checked, className, onChange, unit } = props;
    return (_jsxs("label", Object.assign({ className: `slide_search_list_select_all_checkbox slide_checkbox ${className}`, onClick: stopPropagation, role: 'presentation' }, { children: [_jsx("input", { checked: checked, className: 'item_checkbox', "data-unit": unit.value, onChange: onChange, type: 'checkbox' }), _jsx("div", { className: 'item_checkbox_label' }), _jsx("span", Object.assign({ className: 'checkbox_text' }, { children: "\u3059\u3079\u3066\u9078\u629E" }))] })));
};
SlideSearchListSelectAllCheckbox.propTypes = {
    checked: propBool().isRequired,
    className: propStr(),
    onChange: propFunc().isRequired,
    unit: propShape().isRequired,
};
SlideSearchListSelectAllCheckbox.defaultProps = {
    className: '',
};
export default SlideSearchListSelectAllCheckbox;
